var exports = {
  "k": "xa15a2ab7--0d37e1--container",
};

module.exports = exports;
